module.exports = __webpack_public_path__ + "img/MEDIA001.c827b9c6.jpg";